import {
    loginAccess,
    doForgetPassword,
    doResetPassword,
    doChangeName,
    createAccount,
    getCompleteTutorialData,
    doResendCode
} from './login-access';

export const USER_LOGOUT = 'USER_LOGOUT';
export const WAIT_LOGIN = 'WAIT_LOGIN';
export const DO_LOGIN = 'DO_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const RE_LOGIN_SUCCESS = 'RE_LOGIN_SUCCESS';
export const GET_ACCOUNT_OPERATION_STATUS_BY_LOCAL_STORAGE = 'GET_ACCOUNT_OPERATION_STATUS_BY_LOCAL_STORAGE';
export const GET_ACCOUNT_OPERATION_STATUS_BY_LOCAL_STORAGE_SUCCESS = 'GET_ACCOUNT_OPERATION_STATUS_BY_LOCAL_STORAGE_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const VERIFY_EMAIL_FAIL = 'VERIFY_EMAIL_FAIL';
export const VERIFY_EMAIL_LOADING = 'VERIFY_EMAIL_LOADING';
export const VERIFY_EMAIL_SEND_CODE_FAIL = 'VERIFY_EMAIL_SEND_CODE_FAIL';
export const VERIFY_EMAIL_SEND_CODE_SUCCESS = 'VERIFY_EMAIL_SEND_CODE_SUCCESS';
export const WAIT_FORGOT_PWD = 'WAIT_FORGOT_PWD';
export const LOGIN_CLEAR_MSG = 'LOGIN_CLEAR_MSG';
export const TO_OTHER_PAGE = 'TO_OTHER_PAGE';
export const DO_FORGET_PWD = 'DO_FORGET_PWD';
export const DO_FORGET_PWD_SUCCESS = 'DO_FORGET_PWD_SUCCESS';
export const DO_FORGET_PWD_FAIL = 'DO_FORGET_PWD_FAIL';
export const SHOW_ACCOUNT_CONFIG = 'SHOW_ACCOUNT_CONFIG';
export const CLOSE_ACCOUNT_CONFIG = 'CLOSE_ACCOUNT_CONFIG';
export const SHOW_RESET_PWD = 'SHOW_RESET_PWD';
export const CLOSE_RESET_PWD = 'CLOSE_RESET_PWD';
export const DO_RESET_PWD = 'DO_RESET_PWD';
export const DO_RESET_PWD_SUCCESS = 'DO_RESET_PWD_SUCCESS';
export const DO_RESET_PWD_FAIL = 'DO_RESET_PWD_FAIL';
export const DO_CHANGE_NAME = 'DO_CHANGE_NAME';
export const DO_CHANGE_NAME_SUCCESS = 'DO_CHANGE_NAME_SUCCESS';
export const DO_CHANGE_NAME_FAIL = 'DO_CHANGE_NAME_FAIL';
export const DO_CREATE_ACCOUNT = "DO_CREATE_ACCOUNT";
export const DO_CREATE_ACCOUNT_SUCCESS = "DO_CREATE_ACCOUNT_SUCCESS";
export const DO_CREATE_ACCOUNT_FAIL = "DO_CREATE_ACCOUNT_FAIL";
export const DO_CHANGE_TIMEZONEID_SUCCESS = "DO_CHANGE_TIMEZONEID_SUCCESS";
export const DO_CHANGE_TIMEZONEID_FAIL = "DO_CHANGE_TIMEZONEID_FAIL";
export const GET_COMPLETE_TUTORIAL_DATA = "GET_COMPLETE_TUTORIAL_DATA";
export const GET_COMPLETE_TUTORIAL_DATA_FAIL = "GET_COMPLETE_TUTORIAL_DATA_FAIL";
export const GET_COMPLETE_TUTORIAL_DATA_SUCCESS = "GET_COMPLETE_TUTORIAL_DATA_SUCCESS";

export const doLogin = (account, password, code = null, nextType = DO_LOGIN) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        loginAccess(resolve, reject, account, password, code);
    });

    doPost
    .then((data) => {
        let msg = data.responseMsg;
        if (msg === 'success') {
            let loginParams = {
                authToken: data.authToken,
                accountInfo: data.accountInfo,
                accountRole: data.accountRole,
                roleTableAuth: data.roleTableAuth,
                timeZoneID: data.timeZoneID
            };
            window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN, JSON.stringify(loginParams));

            dispatch({
                type: LOGIN_SUCCESS,
                params: loginParams
            });
        } else if (msg === VERIFY_EMAIL) {
            dispatch({
                type: VERIFY_EMAIL,
                params: {
                    username: account,
                    password: password,
                    notificationContent: data.detailMsg
                }
            });
        } else if (msg === VERIFY_EMAIL_FAIL) {
            dispatch({
                type: VERIFY_EMAIL,
                params: {
                    username: account,
                    password: password,
                    errMsg: data.detailMsg
                }
            });
        } else {
            dispatch({
                type: LOGIN_FAIL,
                params: {
                    errMsg: msg
                }
            });
        }        
    })
    .catch((err) => {
        dispatch({
            type: LOGIN_FAIL,
            params: {
                errMsg: 'Fail: Server no response.'
            }
        });
    });

    dispatch({
        type: nextType
    });
}

export const forgetPassword = (email) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        doForgetPassword(resolve, reject, email);
    });

    doPost
    .then((data) => {
        if (data.responseMsg === "success") {
            dispatch({
                type: DO_FORGET_PWD_SUCCESS,
                params: {
                    sendMail: email
                }
            });            
        } else {
            dispatch({
                type: DO_FORGET_PWD_FAIL,
                params: {
                    errMsg: 'Sorry, we could not find an account with this email.'
                }
            });
        }
    })
    .catch((err) => {
        dispatch({
            type: DO_FORGET_PWD_FAIL,
            params: {
                errMsg: 'Fail: Server no response.'
            }
        });
    });

    dispatch({
        type: DO_FORGET_PWD
    });
}

export const resendCode = (account, password) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        doResendCode(resolve, reject, account, password);
    });

    doPost
        .then((data) => {
            if (data.responseMsg === "success") {
                dispatch({
                    type: VERIFY_EMAIL_SEND_CODE_SUCCESS,
                });
            } else {
                dispatch({
                    type: VERIFY_EMAIL_SEND_CODE_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        })
        .catch((err) => {
            dispatch({
                type: VERIFY_EMAIL_SEND_CODE_FAIL,
                params: {
                    errMsg: 'Fail: Server no response.'
                }
            });
        });

    // dispatch({
    //     type: VERIFY_EMAIL_SEND_CODE_SUCCESS
    // });
}

export const resetPassword = (authToken, accountSeq, oldPwd, pwd) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        doResetPassword(resolve, reject, authToken, accountSeq, oldPwd, pwd);
    });

    doPost
    .then((data) => {
        let msg = data.responseMsg;
        if (msg === 'success') {
            dispatch({
                type: DO_RESET_PWD_SUCCESS
            });
        } else {
            dispatch({
                type: DO_RESET_PWD_FAIL,
                params: {
                    errMsg: msg
                }
            });
        }        
    })
    .catch((err) => {
        dispatch({
            type: DO_RESET_PWD_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: DO_RESET_PWD
    });
}

export const changeAccountName = (authToken, oldUserInfo, oldAccountRole, timeZoneID, reqBodyObj) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        doChangeName(resolve, reject, authToken, reqBodyObj);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            oldUserInfo.name = reqBodyObj.name;
            oldUserInfo.email = reqBodyObj.email;
            const loginParams = {
                authToken: authToken,
                accountInfo: oldUserInfo,
                accountRole: oldAccountRole,
                timeZoneID: timeZoneID
            };
            window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN, JSON.stringify(loginParams));
            const newLoginParams = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN));
            dispatch({
                type: DO_CHANGE_NAME_SUCCESS,
                params: newLoginParams
            });
        } else {
            dispatch({
                type: DO_CHANGE_NAME_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    })
    .catch((err) => {
        dispatch({
            type: DO_CHANGE_NAME_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: DO_CHANGE_NAME
    });
}

export const reLoginBySession = () => (dispatch) => {
    const loginParams = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN));

    dispatch({
        type: RE_LOGIN_SUCCESS,
        params: loginParams
    });
}

export const forwardForgotPwd = () => (dispatch) => {
    dispatch({
        type: WAIT_FORGOT_PWD
    });
}

export const forwardAccountConfig = () => (dispatch) => {
    dispatch({
        type: SHOW_ACCOUNT_CONFIG
    });
}

export const forwardResetPwd = () => (dispatch) => {
    dispatch({
        type: SHOW_RESET_PWD
    });
}

export const closeResetPwd = () => (dispatch) => {
    dispatch({
        type: CLOSE_RESET_PWD
    });
}

export const closeAccountConfig = () => (dispatch) => {
    dispatch({
        type: CLOSE_ACCOUNT_CONFIG
    });
}

export const forwardLogin = (errMsg) => (dispatch) => {
    // return loagin page, clear session login info
    // will keep other reducers state
    sessionStorage.removeItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN);

    dispatch({
        type: LOGIN_FAIL,
        params: {
            errMsg: errMsg
        }
    });
}

export const doLogout = () => (dispatch) => {
    // return loagin page, clear session login info
    sessionStorage.removeItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN);
    sessionStorage.removeItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.SITE);
    sessionStorage.removeItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT_OPERATION_STATUS);


    dispatch({
        type: USER_LOGOUT
    });
}

export const clearErrMsg = () => (dispatch) => {
    dispatch({
        type: LOGIN_CLEAR_MSG
    });
}

export const toOtherPage = () => (dispatch) => {
    dispatch({
        type: TO_OTHER_PAGE
    });
}

export const doCreateAccount = (reqBodyObj) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            createAccount(resolve, reject, reqBodyObj);
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: DO_CREATE_ACCOUNT_SUCCESS
                });
            } else {
                dispatch({
                    type: DO_CREATE_ACCOUNT_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: DO_CREATE_ACCOUNT_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: DO_CREATE_ACCOUNT        
    });
}

export const doChangeTimeZoneId = (timeZoneID) => (dispatch) =>{

    if(timeZoneID){
        const loginParams = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN));
        loginParams.timeZoneID = timeZoneID;
        window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN, JSON.stringify(loginParams));

        dispatch({
            type: DO_CHANGE_TIMEZONEID_SUCCESS,
            params: {
                timeZoneID: timeZoneID
            }
        });
    } else {
        dispatch({
        type: DO_CHANGE_TIMEZONEID_FAIL
    })
    }
    
}

export const doGetCompleteTutorialData = (token, tableSeq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getCompleteTutorialData(resolve, reject, token, tableSeq);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            const loginParams = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN));
            loginParams.accountInfo.completeTutorial = data.data;
            window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN, JSON.stringify(loginParams));

            dispatch({
                type: GET_COMPLETE_TUTORIAL_DATA_SUCCESS,
                params: {
                    accountInfo: loginParams.accountInfo
                }
            });
        } else {
            dispatch({
                type: GET_COMPLETE_TUTORIAL_DATA_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_COMPLETE_TUTORIAL_DATA_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_COMPLETE_TUTORIAL_DATA        
    });
}